'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validate2 = require('./validate');

var _validate3 = _interopRequireDefault(_validate2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Any = require('./rules/Any');

var _Numeric = require('./rules/Numeric');

var _String = require('./rules/String');

var _Date = require('./rules/Date');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Schema = function () {
  function Schema(schema, internals) {
    _classCallCheck(this, Schema);

    this.schema = schema || {};
    this.internals = internals || {};
    this.validate = this.validate.bind(this);
  }

  _createClass(Schema, [{
    key: 'getSchema',
    value: function getSchema() {
      return this.schema;
    }
  }, {
    key: 'field',
    value: function field(fieldName) {
      if (!(fieldName in this.schema)) throw new Error('The supplied field "' + fieldName + '" not found in schema');
      var field = this.schema[fieldName];
      var fieldJSON = _lodash2.default.cloneDeep(field.toJSON());
      switch (true) {
        case field instanceof _Numeric.NumericRule:
          return new _Numeric.NumericRule(fieldJSON);
        case field instanceof _String.StringRule:
          return new _String.StringRule(fieldJSON);
        case field instanceof _Date.DateRule:
          return new _Date.DateRule(fieldJSON);
        case field instanceof _Any.AnyRule:
          return new _Any.AnyRule(fieldJSON);
        default:
      }
    }
  }, {
    key: 'update',
    value: function update(schema) {
      for (var field in schema) {
        if (!(schema[field] instanceof _Any.AnyRule)) throw new Error('Updates to schema require fields to be instances of a type of rule.');
        this.schema[field] = schema[field];
      }
      return this;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var key in this.schema) {
        json[key] = this.schema[key].toJSON();
      }
      return json;
    }
  }, {
    key: 'validate',
    value: function validate(values) {
      return (0, _validate3.default)(values, this);
    }
  }, {
    key: 'onError',
    value: function onError(errorHandler) {
      this.internals.errorHandler = errorHandler;
      return this;
    }
  }, {
    key: 'clone',
    value: function clone() {
      var _this = this;

      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!Array.isArray(fields)) throw new Error('argument supplied for fields must be an array');

      var optionalFields = {};
      var requiredFields = {};

      // Isolate an array of fields to use for the sub-schema and
      // create update objects for optional and required fields
      fields = fields.map(function (field) {
        var parts = field.split(':');
        if (parts.length === 2) {
          if (['o', 'opt', 'optional'].includes(parts[0])) optionalFields[parts[1]] = _this.field(parts[1]).optional();
          if (['r', 'req', 'required'].includes(parts[0])) requiredFields[parts[1]] = _this.field(parts[1]).required();
        }
        return parts[1] || parts[0];
      });

      // Create a new based on the fields
      var newSchema = new Schema(_lodash2.default.pick(this.schema, fields), Object.assign({}, this.internals));
      newSchema.update(optionalFields);
      newSchema.update(requiredFields);
      return newSchema;
    }
  }]);

  return Schema;
}();

exports.default = Schema.bind(Schema);